// extracted by mini-css-extract-plugin
export default {"addUserForm":"AddUser_addUserForm__Wc3lg"};